import { Controller } from "@hotwired/stimulus";
import { parseSignature } from "viem";
import channelService from "../../../services/ChannelService";
import walletService from "../../../services/WalletService";
import httpService from "../../../services/HttpService";
import { emitCheckoutEvent } from "../../../services/checkoutEvents";
import { storage } from "../../../storageconstants";
import { debugError, debugLog } from "../../../utils";
import { errorToastMessages, isUserCancellation, showErrorCard, showErrorToast } from "../../../errorsurfaces";

export default class extends Controller {
  static values = {
    chainid: Number,
    permitid: Number,
    tokensymbol: String,
    session: String,
    typeddata: String,
    permitless: String,
  }

  async connect() {
    this.typedData = JSON.parse(this.typeddataValue);

    debugLog("this.permitlessValue", this.permitlessValue);

    this.permitless = null;
    if (this.permitlessValue) {
      this.permitless = JSON.parse(this.permitlessValue);
      this.permitless.Txhash = this.permitless.Txhash.slice(1, -1);
    }

    this.stopListeningWalletChange();
    this.hideLoadingScreen();
  }

  async proceedToPurchase() {
    let walletClient = walletService.getWalletClient();
    const data = this.typedData;

    if (walletClient) {
      const current_chain = walletService.getCurrentChain();

      if (current_chain != null) {
        const chainId = parseInt(current_chain.id, 16);
        if (chainId != this.chainidValue) {
          debugLog("Connected Chain:", chainId, "is not on desired network:", this.chainidValue);
          await walletService.changeChains(this.chainidValue);
          walletClient = walletService.getWalletClient();
        }
      }

      let signature;
      try {
        signature = await walletClient.signTypedData({
          domain: data.domain,
          message: data.message,
          primaryType: data.primaryType,
          types: data.types,
        });
      } catch (error) {
        emitCheckoutEvent("checkout_cw_tx_rejected", {
          wallet_provider: walletService.getConnectedWalletLabel() || "",
        });
        debugError("Review3rdPartyWallet signTypedData rejected", error?.message || error);
        this.hideLoadingScreen();
        if (isUserCancellation(error)) {
          showErrorToast(errorToastMessages.paymentDeclinedInWallet);
        } else {
          showErrorCard("something-went-wrong", { session: this.sessionValue });
        }
        return;
      }

      emitCheckoutEvent("checkout_cw_tx_approved", {
        asset: this.tokensymbolValue || "",
        network: walletService.getChain(this.chainidValue)?.name || String(this.chainidValue || ""),
        amount_crypto: String(data.message?.value ?? ""),
      });

      // Payment signature obtained — one step before completion.
      emitCheckoutEvent("checkout_payment_signed", {
        asset: this.tokensymbolValue || "",
        network: walletService.getChain(this.chainidValue)?.name || String(this.chainidValue || ""),
        amount_crypto: String(data.message?.value ?? ""),
        signing_method: "connected_wallet",
      });

      data.rawSignature = signature;
      data.signature = parseSignature(signature);

      // Convert v and yParity to strings
      data.signature.v = data.signature.v.toString();
      data.signature.yParity = data.signature.yParity.toString();
      data.address = walletService.getWalletAddress();
    } else {
      await walletService.connectWallet();
      await walletService.changeChains(this.chainidValue);
    }

    data.permitlessFormData = this.permitless;
    data.permitId = this.permitidValue;
    data.tokenSymbol = this.tokensymbolValue;
    data.session = sessionStorage.getItem(storage.SESSION);
    
    try {
      const response = await httpService.post(`/payment/`, data);

      switch (response.type) {
        case "channel":
          channelService.connect(response.data);
          break;
        case "html":
          Turbo.renderStreamMessage(response.data);
          if (response.channel) channelService.connect(response.channel);
          break;
        case "redirect":
          Turbo.visit(response.data);
          break;
      }
    } catch (error) {
      debugError("Review3rdPartyWallet payment/ request error", error.message);
    }
  }

  stopListeningWalletChange() {
    this.dispatch("stopListeningWalletChange");
  }

  showLoadingScreen() {
    this.dispatch("showLoadingScreen", { detail: { text: "Please wait..." } });
  }

  hideLoadingScreen() {
    this.dispatch("hideLoadingScreen");
  }
}
